<template>
  <v-navigation-drawer
    :value="drawer"
    @input="onInput"
    absolute
    temporary
  >
    <v-list nav dense>
      <v-list-item-group>
        <!-- Cerrar al navegar -->
        <v-list-item to="/profile" @click="close">
          <v-list-item-title>Dashboard</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/cuenta" @click="close">
          <v-list-item-title>Mis Datos</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/rewards" @click="close">
          <v-list-item-title>Ticket premiados</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/operations" @click="close">
          <v-list-item-title>Operaciones</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/plays" @click="close">
          <v-list-item-title>Jugadas</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/referidos" @click="close">
          <v-list-item-title>Mis Referidos</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/Accounts" @click="close">
          <v-list-item-title>Mis cuentas</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/Withdrawals" @click="close">
          <v-list-item-title>Historial de retiros</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item to="/Recharges" @click="close">
          <v-list-item-title>Historial de recargas</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <!-- Acciones que antes mutaban la prop -->
        <v-list-item @click="openChangePass">
          <v-list-item-title>Cambiar contraseña</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

       <!--   Pasarela condicional (se mantiene tal cual) 
        <v-list-item class="pt-3 pb-5" v-if="this.$store.state.idmoneda === 2">
          <PayphoneRedirect
            :payphone-store-id="storeId"
            :block="true"
            title="Recargar con Criptos"
            :default-amount-usd="2"
            :default-email="'clecov@gmail.com'"
            :default-phone="'+584140898443'"
            :default-document-id="'14291660'"
            @success="onPagoExitoso"
            @error="onPagoError"
          />
        </v-list-item> -->

        <v-list-item
          dark
          :style="'background:'+colors.primary+';color:#fff'"
          @click="openRecargar"
        >
          <v-list-item-title>RECARGAR SALDO</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>

        <v-list-item
          dark
          style="color:#fff;background-image: linear-gradient(60deg, #a50005 0%, #ff0008 100%);"
          @click="solicitarPago"
        >
          <v-list-item-title>SOLICITAR PAGO</v-list-item-title>
          <v-list-item-action><v-icon class="ml-auto">mdi-menu-right</v-icon></v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// import PayphoneRedirect from '../components/PayphoneRedirect.vue'
// import ProntopagaChile from '../components/ProntopagaChile.vue'
export default {
  components: {
    // PayphoneRedirect,
    // ProntopagaChile
  },
  props: {
    drawer: Boolean,
  },
  computed: {
    marca() {
      return this.$store.state.marca;
    },
    dialogPay: {
      get() {
        return this.$store.state.dialogPay;
      },
      set(v) {
        this.$store.state.dialogPay = v; // se mantiene tu forma actual
      },
    },
    colors() {
      return this.$store.state.colors;
    },
  },
  methods: {
    // Re-emite el input del v-navigation-drawer al padre con el nombre que ya usas: 'update'
    onInput(v) {
      this.$emit('update', v);
    },
    // Cerrar el drawer correctamente (sin mutar la prop)
    close() {
      this.$emit('update', false);
    },
    // Acciones que antes hacían "drawer = false"
    openChangePass() {
      this.$store.state.dialogChangePass = true;
      this.close();
    },
    openRecargar() {
      this.$store.state.dialogRe = true;
      this.close();
    },
    solicitarPago() {
      this.$router.push('/profile');
      this.dialogPay = true; // usa tu computed con set
      this.close();
    },

    // Mantengo este nombre para no romper al padre que escucha @update="update"
    update(e) {
      this.$emit('update', e);
    },
  },
  watch: {
    // Si cambias de ruta mientras está abierto, ciérralo para evitar quedar "pegado"
    $route() {
      this.close();
    },
  },
};
</script>

<style>
/* vacío, lo dejas como estaba */
</style>
